import { useInteractionStore } from '../../stores/interactionStore';
import './hud.css';

/**
 * Einblendung, solange man in einer Raum-Konferenz-Zone steht
 * (Besprechungsraum/Aufenthaltsraum): dort sind alle automatisch verbunden.
 */
export function ZoneCallBanner() {
  const zone = useInteractionStore((s) => s.currentZone);
  const occupants = useInteractionStore((s) => s.zoneOccupants);

  if (!zone || zone.audio !== 'zone') return null;
  const count = occupants[zone.id]?.length ?? 1;

  return (
    <div className="zone-call-banner" role="status">
      🔊 {zone.name} — Raum-Konferenz:{' '}
      {count > 1 ? `alle ${count} Personen verbunden` : 'nur du im Raum'}
    </div>
  );
}
